export default "__VITE_ASSET__UVDCIYyK__"